import { Mail, ArrowRight } from "lucide-react";
import PageHero, { usePageTitle } from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";
import { VALUES, CONTACT } from "@/data/content";

export default function BolsaDeTrabajo() {
  usePageTitle("Talento | BRIK Procurement Partners");
  return (
    <>
      <PageHero
        eyebrow="Talento"
        titleLines={["Construyamos el futuro", "del Procurement juntos."]}
        description="Buscamos personas con visión, curiosidad y ganas de transformar la función de Compras a través de estrategia, inteligencia y ejecución."
        image="/brand/brand-meeting.webp"
        alt="Equipo BRIK en sesión de trabajo — únete al equipo"
      />

      <section data-testid="culture-section" className="bg-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            eyebrow="La forma BRIK de trabajar"
            title="Personas primero. Siempre."
            description="Creemos que las mejores estrategias comienzan con las personas. Buscamos construir un entorno donde el talento pueda aportar ideas, asumir retos, aprender y generar un impacto real."
          />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-oxford/10 border border-oxford/10">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08} className="h-full">
                <div className="group relative h-full bg-white p-8 flex flex-col items-center text-center transition-colors duration-300 hover:bg-bone" data-testid={`value-card-${i + 1}`}>
                  <span className="absolute top-0 left-0 h-[2px] w-0 bg-gold transition-all duration-500 group-hover:w-full" />
                  <v.icon className="h-10 w-10 text-gold" strokeWidth={1.5} />
                  <h3 className="mt-5 font-display text-sm font-semibold tracking-[0.12em] uppercase text-oxford">{v.title}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="openings-section" className="bg-bone">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32 grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <SectionHeader eyebrow="Vacantes" title="Tu próximo reto puede empezar aquí." />
            <Reveal delay={0.2}>
              <p className="mt-8 text-base leading-relaxed text-carbon/70 max-w-lg">
                Por el momento no tenemos vacantes publicadas, pero siempre nos interesa conocer a personas con talento, visión de negocio y pasión por el Procurement.
              </p>
            </Reveal>
            <Reveal delay={0.28}>
              <p className="mt-4 text-base leading-relaxed text-carbon/70 max-w-lg">
                Si quieres formar parte de una firma que está redefiniendo la función de Compras, este es el lugar para presentarte.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.25}>
            <div className="relative border border-oxford/10 bg-white p-10 lg:p-12">
              <span className="absolute top-0 left-0 h-[2px] w-24 bg-gold" />
              <span className="flex h-14 w-14 items-center justify-center bg-oxford">
                <Mail className="h-6 w-6 text-gold" strokeWidth={1.5} />
              </span>
              <h3 className="mt-7 font-display text-xl font-semibold text-oxford">Queremos conocerte</h3>
              <p className="mt-3 text-sm leading-relaxed text-carbon/70">
                Compártenos tu experiencia, tus áreas de especialidad y cómo te gustaría contribuir a BRIK. Revisamos personalmente cada perfil.
              </p>
              <a
                href={`mailto:${CONTACT.email}?subject=CV%20%E2%80%94%20Talento%20BRIK`}
                data-testid="cv-email-button"
                className="btn-gold mt-8"
              >
                Enviar mi CV <ArrowRight className="h-4 w-4" strokeWidth={2} />
              </a>
              <p className="mt-5 text-xs text-steel">{CONTACT.email}</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
